export default {"src":"/_next/static/media/qr.8aaff994.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};